<template>
  <accordion-section
    :open="section === 5"
    :valid="!!websiteUri"
    @selected="$emit('openSection', 5)"
  >
    <template #heading>
      Website Url
    </template>

    <custom-input
      v-model="websiteUri"
      label="Enter your business website URL"
      :disabled="!canEditLocation"
      :validation-errors="validationErrors['websiteUri']"
    />

    <div class="recommendations">
      <span>Recommendations</span>
      <p class="sub">
        Properly format your URLs:
      </p>
      <ul>
        <li>All URLs must be live at the time you enter them into Google My Business.</li>
        <li>Use https:// or http:// and include or omit the www as appropriate.</li>
        <li>
          Add Google Analytics UTM tracking codes to your URL.
          This helps you see in Google Analytics how many people came to your website from your GMB listing.
        </li>
      </ul>

      <p class="sub">
        Website URL:
      </p>
      <ul>
        <li>For single-location businesses, use the homepage of your website.</li>
        <li>For multi-location businesses, use the specific page for each location.</li>
        <li>
          Example website URL with UTM tracking:
          https://localmarketinginstitute.com/?utm_source=google&utm_medium=local&utm_campaign=1&utm_content=primary
        </li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import AccordionSection from "../items/AccordionSection";
import {mapActions, mapGetters, mapMutations} from "vuex";
import CustomInput from "../../../../../views/reports/components/global/forms/CustomInput";

export default {
  components: {
    CustomInput,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    websiteUri: {
      get() {
        return this.$store.getters['businessProfile/websiteUri'];
      },
      set(value) {
        this.updateWebsiteUri(value);
      }
    },
    ...mapGetters('user', [
        'canEditLocation'
    ]),
    ...mapGetters('businessProfile', [
      'validationErrors',
    ]),
  },
  methods: {
    ...mapMutations('editListing', [
      'setSelectedSection',
    ]),
    ...mapActions('businessProfile', [
      'updateWebsiteUri',
    ])
  },
}
</script>
